import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["data"],
    _excluded2 = ["data"],
    _excluded3 = ["data"],
    _excluded4 = ["data"];

var _templateObject, _templateObject2;

import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery as useGQLQuery } from '@apollo/client';
import { useQuery } from '@tanstack/react-query';
import gql from 'graphql-tag';
import { useRouter } from 'next/router';
import * as R from 'ramda';
import { useMemo } from 'react';
import { getGroupedTopicGuides } from 'src/components/TopicGuide/utils';
import { BranchConstants, getSurveyIdList } from 'src/constants';
import { getDietBriefFromSurvey, getTargetBriefFromSurvey, mapSurveyFormIdsFromSurveyTypes } from 'src/utils';
import API from './API';
export var SurveysQueryGQL = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Surveys($surveyFormIds: [Int!], $clientId: Int) {\n    surveys(where: { survey_form_id: { _in: $surveyFormIds }, target_id: { _eq: $clientId } }) {\n      id\n      name\n      survey_form_id\n      taken_at\n      is_draft\n    }\n  }\n"])));
export var SurveyAnswerQueryGQL = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query SurveyAnswer($surveyFormIds: [Int!], $clientId: Int) {\n    surveys(where: { survey_form_id: { _in: $surveyFormIds }, target_id: { _eq: $clientId } }) {\n      id\n      name\n      survey_form_id\n      taken_at\n      updated_at\n      is_draft\n      survey_answers {\n        answer\n        question_id\n      }\n    }\n  }\n"])));
export var useSurveyFillState = function useSurveyFillState(clientId, types) {
  var _useMemo = useMemo(function () {
    var surveyTypeIdMap = Object.fromEntries(types.map(function (type) {
      return [type, getSurveyIdList(type, BranchConstants.ORG_TYPE)];
    }));
    var surveyFormIds = Object.values(surveyTypeIdMap).flat();
    return {
      surveyTypeIdMap: surveyTypeIdMap,
      surveyFormIds: surveyFormIds
    };
  }, [types]),
      surveyTypeIdMap = _useMemo.surveyTypeIdMap,
      surveyFormIds = _useMemo.surveyFormIds;

  var _useGQLQuery = useGQLQuery(SurveysQueryGQL, {
    variables: {
      clientId: clientId,
      surveyFormIds: surveyFormIds
    },
    skip: !clientId || surveyFormIds.length === 0
  }),
      data = _useGQLQuery.data,
      others = _objectWithoutProperties(_useGQLQuery, _excluded);

  var result = useMemo(function () {
    if (!data) {
      return {};
    }

    var filledIdSet = new Set(data.surveys.map(function (survey) {
      return survey.survey_form_id;
    }));
    return R.mapObjIndexed(function (ids) {
      return ids.some(function (id) {
        return filledIdSet.has(id);
      });
    }, surveyTypeIdMap);
  }, [data, surveyTypeIdMap]);
  return _objectSpread({
    data: result
  }, others);
};
export var useGetSurveyAnswers = function useGetSurveyAnswers(clientId, types) {
  var _useRouter = useRouter(),
      locale = _useRouter.locale;

  var _useMemo2 = useMemo(function () {
    var surveyTypeIdMap = Object.fromEntries(types.map(function (type) {
      return [type, getSurveyIdList(type, BranchConstants.ORG_TYPE)];
    }));
    var surveyFormIds = Object.values(surveyTypeIdMap).flat();
    return {
      surveyFormIds: surveyFormIds
    };
  }, [types]),
      surveyFormIds = _useMemo2.surveyFormIds;

  var _useGQLQuery2 = useGQLQuery(SurveyAnswerQueryGQL, {
    variables: {
      clientId: clientId,
      surveyFormIds: surveyFormIds
    },
    skip: !clientId || !(surveyFormIds !== null && surveyFormIds !== void 0 && surveyFormIds.length)
  }),
      data = _useGQLQuery2.data,
      others = _objectWithoutProperties(_useGQLQuery2, _excluded2);

  var _useMemo3 = useMemo(function () {
    var _data$surveys;

    return {
      surveyFilled: (data === null || data === void 0 ? void 0 : (_data$surveys = data.surveys) === null || _data$surveys === void 0 ? void 0 : _data$surveys.length) > 0
    };
  }, [data]),
      surveyFilled = _useMemo3.surveyFilled;

  var _useMemo4 = useMemo(function () {
    var splitter = locale === 'en-US' ? ', ' : '，';
    var targetBrief = getTargetBriefFromSurvey(data === null || data === void 0 ? void 0 : data.surveys, splitter);
    var dietBrief = getDietBriefFromSurvey(data === null || data === void 0 ? void 0 : data.surveys, splitter);
    return {
      targetBrief: targetBrief,
      dietBrief: dietBrief
    };
  }, [data, locale]),
      targetBrief = _useMemo4.targetBrief,
      dietBrief = _useMemo4.dietBrief;

  return _objectSpread({
    data: data,
    surveyFilled: surveyFilled,
    targetBrief: targetBrief,
    dietBrief: dietBrief
  }, others);
};
export var useGetSurvey = function useGetSurvey(clientID, types) {
  var surveyFormIds = useMemo(function () {
    return mapSurveyFormIdsFromSurveyTypes(types);
  }, [types]);

  var _useQuery = useQuery({
    queryKey: ['getSurveyAnswers', clientID, surveyFormIds],
    queryFn: function queryFn() {
      return API.getSurveyAnswers(surveyFormIds, clientID);
    },
    enabled: !!(surveyFormIds !== null && surveyFormIds !== void 0 && surveyFormIds.length)
  }),
      data = _useQuery.data,
      others = _objectWithoutProperties(_useQuery, _excluded3);

  var surveys = useMemo(function () {
    return R.pipe(R.pathOr([], ['data', 'surveys']), R.filter(function (survey) {
      return R.any(function (question) {
        return R.length((question === null || question === void 0 ? void 0 : question.client_memos) || []) > 0;
      }, survey === null || survey === void 0 ? void 0 : survey.questions);
    }), R.sort(function (a, b) {
      var _b$survey, _b$survey$updated_at, _a$survey;

      return b === null || b === void 0 ? void 0 : (_b$survey = b.survey) === null || _b$survey === void 0 ? void 0 : (_b$survey$updated_at = _b$survey.updated_at) === null || _b$survey$updated_at === void 0 ? void 0 : _b$survey$updated_at.localeCompare(a === null || a === void 0 ? void 0 : (_a$survey = a.survey) === null || _a$survey === void 0 ? void 0 : _a$survey.updated_at, undefined, {
        numeric: true
      });
    }), R.pathOr([], [0, 'questions']), R.filter(function (question) {
      return R.length((question === null || question === void 0 ? void 0 : question.client_memos) || []) > 0;
    }))(data || {});
  }, [data]);
  return _objectSpread({
    data: data,
    surveys: surveys
  }, others);
};
export var useGetSurveyTopicGuideAnswers = function useGetSurveyTopicGuideAnswers(clientID, types) {
  var _useQuery2 = useQuery({
    queryKey: ['getSurveyTopicGuideAnswers', clientID, types],
    queryFn: function () {
      var _queryFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var topicGuides, promises, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                topicGuides = {};
                promises = types.map(function (type) {
                  var surveyFormIds = mapSurveyFormIdsFromSurveyTypes([type]);
                  return API.getSurveyTopicGuideAnswers(surveyFormIds, clientID);
                });
                _context.next = 4;
                return Promise.all(promises);

              case 4:
                data = _context.sent;
                types.forEach(function (type, index) {
                  topicGuides[type] = getGroupedTopicGuides(data[index].data.survey_answers || []);
                });
                return _context.abrupt("return", topicGuides);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function queryFn() {
        return _queryFn.apply(this, arguments);
      }

      return queryFn;
    }(),
    enabled: !!(types !== null && types !== void 0 && types.length)
  }),
      data = _useQuery2.data,
      others = _objectWithoutProperties(_useQuery2, _excluded4);

  return _objectSpread({
    data: data
  }, others);
};